import Vue from 'vue'
import Router from 'vue-router'
import GenerateCertificate from '@/views/GenerateCertificate'
import NotFoundPage from '@/views/NotFoundPage'
import VerifyCertificate from '@/views/VerifyCertificate'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'GenerateCertificate',
      component: GenerateCertificate,
      meta: {
        title: 'Ayuntamiento de Artenara - Solicitud de Certificado de Viajes'
      }
    },
    {
      path: '/verifica',
      name: 'VerifyCertificate',
      component: VerifyCertificate,
      meta: {
        title: 'Ayuntamiento de Artenara - Verificación de Certificado de Viajes'
      }
    },
    {
      path: '*',
      name: 'NotFoundPage',
      component: NotFoundPage,
      meta: {
        title: 'Ayuntamiento de Artenara - Error'
      }
    }
  ],
  mode: 'history'
})




// WEBPACK FOOTER //
// ./src/router/index.js